import React, { useEffect, useState } from "react";
import { Delete, Pen } from "lucide-react";
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import UnitForm from "./unit_form";
import { createRawCategory, deleteRawCategory, fetchRawCategories, updateRawCategory } from "../../../../slices/company/rawCategorySlice";
import CategoryForm from "./category_form";
import { fetchUnits } from "../../../../slices/company/unitsSlice";
import { fetchTaxes } from "../../../../slices/company/taxSlices";
import { customTableStyles } from "../../../../utils/tableStylings";

const RawCategories = () => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // To control modal visibility
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [modalHeading, setModalHeading] = useState('');
    const { rawCategories } = useSelector(state => state.rawCategories);
    const { units } = useSelector(state => state.accountingUnits);
    const { taxes } = useSelector(state => state.accountingTaxes);


    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            dispatch(fetchRawCategories(companyId));
            dispatch(fetchUnits(companyId));
            dispatch(fetchTaxes(companyId));
        }
    }, [dispatch]);


    const handleFormSubmit = (formData) => {
        if (selectedCategory && selectedCategory?.id != null) {
            dispatch(updateRawCategory({ id: selectedCategory.id, rawCategoryData: formData }));

        } else {
            const company = JSON.parse(localStorage.getItem('company'));

            const formDataObj = {
                ...formData,
                company_id: company.company?.id
            };
            dispatch(createRawCategory(formDataObj));
        }
        setShowModal(false);
    };


    const handleEditTax = (categoryData) => {
        setSelectedCategory(categoryData);
        setModalHeading('Edit Raw Category') // Pass the supplier data to edit
        setShowModal(true);
    };

    const handleDelete = (taxId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Category.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteRawCategory(taxId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Category has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });

            }
        });

    };


    const unitColumn = [
        {
            name: '#',
            cell: (row, index) => index + 1, // Show index of the row
            width: '50px'
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true
        },
        {
            name: 'Unit',
            selector: row => row.Unit?.name,
            sortable: true
        },
        {
            name: 'Parent Category',
            selector: row => {
                const parent = rawCategories.find(cat => cat.id === row.parent_id);
                return parent ? parent.name : 'N/A';
            },
            sortable: true
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                    <span
                        className="text-warning cursor-pointer me-2"
                        onClick={() => handleEditTax(row)}
                    >
                        <Pen />
                    </span>
                    <span
                        className="text-danger cursor-pointer"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete />
                    </span>
                </>
            ),
            width: '150px'
        }
    ];

    const handleAdd = () => {
        setSelectedCategory([]);
        setModalHeading('Create Raw Category');// No supplier means we are adding a new one
        setShowModal(true);
    };



    return (
        <>
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center mb-3">
                    <h3 className="text-primary mb-0">Categories</h3>
                    <button
                        className="btn btn-primary"
                        onClick={() => handleAdd()}
                    >
                        + Add Category
                    </button>
                </div>
                <div className="card-body">
                    {
                        rawCategories && rawCategories.length > 0 ? (
                            <DataTable

                                columns={unitColumn}
                                data={rawCategories}
                                pagination
                                highlightOnHover
                                striped
                                dense
                                customStyles={customTableStyles}
                            />
                        ) : (
                            <p>No Data Found</p>
                        )
                    }
                </div>
            </div>
            <CategoryForm show={showModal} onClose={() => setShowModal(false)} heading={modalHeading} initialData={selectedCategory} onSubmit={handleFormSubmit} units={units} parentCategories={rawCategories} />
        </>
    );
}

export default RawCategories;